module.exports = __webpack_public_path__ + "static/media/facebook-filled.36311c31.svg";